import React, { useState } from "react";
import { getCookie } from '../utils/cookies';
import { authFetchRequest } from "../utils/api";

const LogoUpload = () => {
    const [file, setFile] = useState(null);
    const [message, setMessage] = useState("");

    const handleFileChange = (event) => {
        setFile(event.target.files[0]);
    };

 

    const handleUpload = async () => {
        if (!file) {
            setMessage("Please select a file first.");
            return;
        }

        const formData = new FormData();
        formData.append("logo", file);

        try {
            const response = await authFetchRequest(
                "/company/upload-logo",
                formData,
                "POST",
                {
                    Authorization: `Bearer ${getCookie("access_token")}`
                }
            );
            setMessage(response.message || "Logo uploaded successfully!");
        } catch (error) {
            console.error("Upload error:", error); // <- Add this for debugging
            setMessage("Failed to upload logo. Please try again.");
        }
    };


    return (
        <div>
            <input type="file" onChange={handleFileChange} accept="image/*" />
            <button onClick={handleUpload} className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700">
                Upload Logo
            </button>
            {message && <div className="mt-2">{message}</div>}
        </div>
    );
};

export default LogoUpload;